export function SecuritySettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Security Settings
        </h2>
        <p className="text-sm text-muted-foreground">
          Manage your account security and authentication
        </p>
      </div>
      
      <div className="text-center py-12">
        <p className="text-muted-foreground">Security settings coming soon...</p>
      </div>
    </div>
  )
}